import React from "react";
import {Link} from "react-router";

import Chart from "./UI/Chart/Chart";

import {api, parsePHPtime} from "./baseFunctions";
import langs from "./langs/phpIndex";
import appLangs from "./langs/appIndex";

import "./css/weeklyReport.css";
export default class WeeklyReportPage extends React.Component {
	constructor(){
		super();
		this.load = this.load.bind(this);
		this.state = {
			obs: false,
			obsExtras: [],
			extraData: [],
			last: false,
			this: false,
			target: false,
			error: false,
		};
	}

	componentDidMount(){
		this.load();
	}
	componentDidUpdate(prevProps) {
		if(this.props.params.hash !== prevProps.params.hash)
		{
			this.load();
		}
	}

	componentWillUnmount(){
		document.body.classList.toggle("inReport");
	}

	load(){
		api("POST", {type: "weeklyReport", hash: this.props.params.hash}, (d) => {
			if(!d.error)
			{
				this.setState({
					obs: d.data.obs,
					obsExtras: d.data.obsExtras,
					extraData: d.data.obsData,
					last: d.data.last,
					this: d.data.this,
					target: d.data.target,
				});
				/*setTimeout(() => {
					requestAnimationFrame(() => window.print())
				}, 500);*/
			}else{
				this.setState({error: true});
			}
		}, false, 1);
	}

	render(){
		let fix = {
			"UK": "EN",
			"EN": "EN",
			"DK": "DK"
		};
		let langKey = fix[this.props.params.lang] ? fix[this.props.params.lang] : "DK";
    const APP_LANG = appLangs[langKey];
		const LANG = langs[langKey];
		let actionColors = ["red", "rgb(199, 199, 8)", "green"];

		if(!document.body.classList.contains("inReport"))
		{
			document.body.classList.toggle("inReport");
		}
		return (
			<div>
				{
					this.state.this ?
						<Chart lang={langKey} type="OBS_KPI" data={{obsMonths: {this: this.state.this, last: this.state.last, target: this.state.target}}}/>
					: null
				}
				{
					this.state.obs ?
						<table className="table table-striped jambo_table bulk_action" id="ras">
			    		<thead>
			          <tr className="headings">
			          	<th className="column-title"># </th>
		              <th className="column-title">{LANG.STARTED_DATE}</th>
		              <th className="column-title">{LANG.BY}</th>
		              {
                    this.state.extraData.map((d, key) => <th key={key} className="column-title">{APP_LANG[d.langCode]}</th>)
                  }
		              {/* <th className="column-title">{LANG.ADDRESS}</th> */}
		              <th className="column-title">{LANG.STATUS}</th>
		              <th className="column-title"></th>
			          </tr>
			      	</thead>
			        <tbody>
			        {
			        	this.state.obs.map((d, key) =>  {
			        		let extras = this.state.obsExtras.filter(dat => dat.parentID == d.id).reverse();
			        		return (<tr className={key%2 ? "even pointer" : "odd pointer"} key={key}>
			          	<td className="column-title">{d.id}</td>
		              <td className="column-title">{parsePHPtime(Number(d.unix) / 1000)}</td>
		              <td className="column-title">{d.createdBy}</td>
		              {
                    this.state.extraData.map((d2, key2) => {
                      let extVal = extras && extras[key2] ? extras[key2] : false;
                      return (<td className=" " key={key2}>{extVal && extVal[LANG.key].length > 0 ? extVal[LANG.key] : extVal.value}</td>);
                    })
                  }
		              {/* <td className="column-title">{d.address}</td> */}
		              <td className=" " style={{color: actionColors[d.status]}}>
                    <i className="fa fa-circle" aria-hidden="true"></i> {LANG.STATUS_ARR[d.status]}
                  </td>
		              <td className="column-title">
		              	<a target="_blank" href={"/#/publicReport/" + d.id + "/EN/" + d.answerHash}>{LANG.EXTERNAL_REP}</a> 
		              </td>
			          </tr>);
			        	})
			        }
			        </tbody>
			      </table>
					: <center>Loading</center>
				}
			</div>);
	}
}


// WEBPACK FOOTER //
// ./src/components/WeeklyReportPage.js